import React, { useContext, useEffect, useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import {
  MsgError,
  MsgLoading,
  MsgSuccess,
} from "../../../components/Loaders/MessageLoaders";
import { PkgDetailResType } from "../../../helpers/types/global";
import PkgDestinationCategoriesService from "../../../services/PkgDestinationCategories.service";
import PkgService from "../../../services/PkgService";
import { PkgDesCatInputs } from "../page-categories/TabAddPkgCategories";
import { IPkgDestinationCategory } from "../../../types/enums/API.types";
import LangContext from "../../../context/LanguageContext";

export type PkgInputs = {
  title: string;
  starting_price: number;
  day: number;
  night: number;
  isPkgFeatured: boolean;
  // overview: string;
  package_img: any;
  // imp_info: string;
  // itinary: string;
  pkg_destination_category: string;
  meta_description: string;
  meta_keywords: string;
};

type propsType = {
  EditPkg?: PkgDetailResType;
  refresh?: () => void;
};

const TabAddPackages = (props: propsType) => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
    setValue,
  } = useForm<PkgInputs>();

  const { lang_id } = useContext(LangContext);

  const [pkg_destination_cat, setPkgDestCat] = useState<
    IPkgDestinationCategory[]
  >([]);

  const onSubmit: SubmitHandler<PkgInputs> = async (data) => {
    data["package_img"] = data.package_img[0] || props.EditPkg?.package_img;
    console.log(data.package_img);
    console.log("-----", data);
    if (props.EditPkg) {
      handleEdit(data);
    } else {
      try {
        MsgLoading();
        const res = await PkgService.createPkg(data);
        MsgSuccess(res.data.message);
      } catch (error: any) {
        if (error.response) {
          MsgError(error.response.data.message);
        }
      }
    }
  };
  const setEditValues = (editPkg: PkgDetailResType) => {
    // alert('inside edit value')
    setValue("title", editPkg.title);
    setValue("starting_price", editPkg.starting_price);
    setValue("day", editPkg.day);
    setValue("night", editPkg.night);
    setValue("isPkgFeatured", editPkg.isPkgFeatured);
    setValue("pkg_destination_category", editPkg.pkg_destination_category.id);
    setValue("meta_description", editPkg.meta_description);
    setValue("meta_keywords", editPkg.meta_keywords);
  };

  const handleEdit = async (data: PkgInputs) => {
    try {
      MsgLoading();
      const res = await PkgService.updatePkg(props.EditPkg?.id!, data);
      MsgSuccess(res.data.message);
      if (props.refresh) {
        props.refresh();
      }
    } catch (error: any) {
      console.log(error);
      MsgError(error.response.data.message);
    }
  };
  useEffect(() => {
    try {
      if (props.EditPkg) {
        setEditValues(props.EditPkg);
      }
      PkgDestinationCategoriesService.getAllPkgDestCat().then((res) => {
        setPkgDestCat(res.data.data);
      });
    } catch (error) {
      console.log(error);
    }
  }, [props.EditPkg]);

  return (
    <div>
      <form action="" onSubmit={handleSubmit(onSubmit)}>
        <div className="grid grid-cols-2 gap-5">
          <div className="flex flex-col space-y-2">
            <label htmlFor="title">Package title</label>
            <input
              type="text"
              id="title"
              className="form-input inputs"
              {...register("title", { required: true })}
            />
            {errors.title && (
              <span className="text-red-500">This field is required</span>
            )}
          </div>

          <div className="flex flex-col space-y-2">
            <label htmlFor="pkg_destination_cat">
              Package Destination Category
            </label>
            <select
              id="pkg_destination_cat"
              className="form-input inputs"
              {...register("pkg_destination_category", { required: true })}
            >
              <option value="">--select--</option>
              {pkg_destination_cat.map((item) => (
                <option value={item.id} key={item.id}>
                  {item.translations.map((trans, i) => {
                    if (String(trans.lang_id.id) === lang_id) {
                      return trans.category_title;
                    }
                    return null;
                  })}
                </option>
              ))}
            </select>
            {errors.pkg_destination_category && (
              <span className="text-red-500">This field is required</span>
            )}
          </div>

          <div className="flex flex-col space-y-2">
            <label htmlFor="meta_description">Package SEO description</label>
            <textarea
              rows={4}
              id="meta_description"
              className="form-input inputs"
              {...register("meta_description", { required: true })}
            ></textarea>

            {errors.meta_description && (
              <span className="text-red-500">This field is required</span>
            )}
          </div>

          <div className="flex flex-col space-y-2">
            <label htmlFor="meta_keywords">Package SEO Keywords</label>
            <textarea
              rows={4}
              id="meta_keywords"
              className="form-input inputs"
              {...register("meta_keywords", { required: true })}
            ></textarea>

            {errors.meta_keywords && (
              <span className="text-red-500">This field is required</span>
            )}
          </div>

          <div className="flex flex-col space-y-2">
            <label htmlFor="price">Starting price</label>
            <input
              type="number"
              id="price"
              className="form-input inputs"
              {...register("starting_price", { required: true })}
            />
            {errors.starting_price && (
              <span className="text-red-500">This field is required</span>
            )}
          </div>

          <div className="flex flex-col space-y-2">
            <label htmlFor="day">Day</label>
            <input
              type="number"
              id="day"
              className="form-input inputs"
              {...register("day", { required: true })}
            />
            {errors.day && (
              <span className="text-red-500">This field is required</span>
            )}
          </div>

          <div className="flex flex-col space-y-2">
            <label htmlFor="night">Night</label>
            <input
              type="number"
              id="night"
              className="form-input inputs"
              {...register("night", { required: true })}
            />
            {errors.night && (
              <span className="text-red-500">This field is required</span>
            )}
          </div>

          <div className="flex flex-col space-y-2">
            <label htmlFor="img">Package Imgage</label>
            <input
              type="file"
              id="img"
              className="form-input inputs"
              {...register("package_img", { required: false })}
            />
            {errors.package_img && (
              <span className="text-red-500">This field is required</span>
            )}
          </div>
        </div>

        <div className="flex space-x-2 my-4">
          <input
            type="checkbox"
            id="isFeatured"
            {...register("isPkgFeatured")}
          />
          <label htmlFor="isFeatured">Is this package Featured ?</label>
        </div>

        <div className="flex flex-col space-y-2">
          <input type="submit" value={"Submit"} className="btn btn-primary" />
        </div>
      </form>
    </div>
  );
};

export default TabAddPackages;
